import { useMemo } from 'react'
import { companyOtherInfoFieldsConfig, contactOtherInfoFieldsConfig } from '../../../api/contacts/formValuesConfig'
import contacts from '../../../api/contacts/hooks'
import { Contact } from '../../../api/contacts/types'
import { ContactType } from '../../../api/globalTypes'
import { contactOtherInfoFields } from '../../../common/forms/contacts/fields'
import { mapValuesToFormFields } from '../../../utils/formUtils/forms'

export const useContactOtherInfoFormSelectOptions = (data: Contact | null = null, contactType: ContactType = ContactType.Person) => {
    const fieldsConfig = contactType === ContactType.Person ? contactOtherInfoFieldsConfig : companyOtherInfoFieldsConfig

    const personFormFields = ['description', 'gender', 'jobTitle', 'maritalStatus', 'country']
    const companyFormFields = ['coreBusiness', 'companySize']

    const contactFormFields = contactType === ContactType.Person ? personFormFields : companyFormFields

    const { data: contactValues, isPending } = contacts.FormValues.useQuery(contactFormFields)

    const companySelectOptions = useMemo(() => {
        if (contactType !== ContactType.Person) return {}

        const companies = data?.contactPersonCompany
        
        if (companies?.length) {
            return {
                [contactOtherInfoFields.COMPANY_ID]: companies.map((item) => ({
                    label: item?.company?.contactCompany?.name,
                    value: item?.company?.id?.toString(),
                })),
            }
        }

        return {}
    }, [contactType, data])

    const contactSelectOptions = useMemo(() => {
        return mapValuesToFormFields(contactValues, fieldsConfig)
    }, [contactValues, fieldsConfig])

    const selectOptions = useMemo(
        () => ({
            ...contactSelectOptions,
            ...companySelectOptions,
        }),
        [contactSelectOptions, companySelectOptions]
    )

    return { selectOptions, isPending }
}
